var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 7.32103C2 4.3823 4.3823 2 7.32103 2C10.2597 2 12.6421 4.3823 12.6421 7.32103C12.6421 8.74901 12.0795 10.0456 11.164 11.0013C11.1343 11.025 11.1056 11.0505 11.0781 11.0781C11.0505 11.1056 11.025 11.1343 11.0013 11.164C10.0456 12.0795 8.74901 12.6421 7.32103 12.6421C4.3823 12.6421 2 10.2597 2 7.32103ZM11.7424 13.1566C10.514 14.0889 8.98209 14.6421 7.32103 14.6421C3.27773 14.6421 0 11.3643 0 7.32103C0 3.27773 3.27773 0 7.32103 0C11.3643 0 14.6421 3.27773 14.6421 7.32103C14.6421 8.9821 14.0889 10.514 13.1566 11.7424L15.9293 14.5151C16.3199 14.9056 16.3199 15.5388 15.9293 15.9293C15.5388 16.3199 14.9056 16.3199 14.5151 15.9293L11.7424 13.1566Z",
    fill: "#878787"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.6646ff7e4888eb27e1865059d2df48d6.svg";
export { ForwardRef as ReactComponent };